/**
 * plan 分段控件（plan-page-design ref 02「分段控件」、ref 03 §3；PR5 新写，admin 无此组件）。
 * 形状照 Loop `SubTabBtn`（胶囊、选中橙底橙字）改名收成一组；**只用在对象级**（轨迹抽屉右栏切详情类型）和图表维度切换。
 */
import { cn } from "@/lib/utils";

export type SegmentedOption<T extends string> = { value: T; label: string };

export function Segmented<T extends string>({
	options,
	value,
	onChange,
	testId,
}: {
	options: SegmentedOption<T>[];
	value: T;
	onChange: (v: T) => void;
	testId?: string;
}) {
	return (
		<div className="inline-flex flex-wrap items-center gap-1" role="tablist" data-testid={testId}>
			{options.map((o) => (
				<button
					key={o.value}
					type="button"
					role="tab"
					aria-selected={o.value === value}
					onClick={() => onChange(o.value)}
					className={cn(
						"rounded-full px-2.5 py-1 text-xs font-medium transition-colors duration-150",
						o.value === value
							? "bg-brand-accent/10 text-brand-accent"
							: "text-text-secondary hover:text-text-primary",
					)}
				>
					{o.label}
				</button>
			))}
		</div>
	);
}
